import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

@Component({
    selector: 'gtw-credits-part-iii-f8941',
    templateUrl: './credits-part-iii-f8941.component.html',
    styleUrls: ['./credits-part-iii-f8941.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CreditsPartIIIF8941Component {
  @Input() activeTab: string = '';
  @Input() currentFormHeader: any = null;
  @Input() tableHeader: any[] = [];
  @Input() outerList: any[] = [];
  @Input() formList: any[] = [];
  @Input() formLOV: any[] = [];

  @Input() parts: string[] = [];
  @Input() presentTabClicked: string = '';
  @Input() subTableHeaderSelected: any[] = [];
  @Input() formHeaderName: string = '';

  @Output() innerTabSelect = new EventEmitter<string>();
  @Output() fieldChange = new EventEmitter<{ item: any; value: any }>();
  @Output() dateChange = new EventEmitter<{ item: any; event: Event }>();
  @Output() dateVariousChange = new EventEmitter<any>();
  @Output() dropdownChange = new EventEmitter<{ item: any; value: any }>();
  @Output() checkboxChange = new EventEmitter<{ item: any; event: any }>();
  @Output() checkBox8941 = new EventEmitter<{ lineKey: any; attribKey: any; attribCol: any }>();

  get isEntry(): boolean {
    return this.presentTabClicked === 'F8941';
  }

  get isWS(): boolean {
    return !this.isEntry;
  }

  get hideDescription(): boolean {
    return this.presentTabClicked === 'WS1' || this.presentTabClicked === 'WS4';
  }

  get rows(): any[] {
    return (this.outerList || []).filter((r: any) =>
      r.IS_FORM_DISPLAY === 'Y'
      && r.PART_NO === this.presentTabClicked
      && r.ROW_TYPE !== 'FH'
    );
  }

  isRegularRow(row: any): boolean {
    return row?.ROW_TYPE !== 'PH' && row?.ROW_TYPE !== 'DTA';
  }

  getNonRadioCells(lineKey: any): any[] {
    return (this.formList || []).filter(
      (x: any) => x.FORM_LINE_KEY === lineKey
        && x.IS_FORM_DISPLAY === 'Y'
        && x.EDIT_TYPE !== 'radio'
    );
  }

  getDTACells(lineKey: any): any[] {
    return (this.formList || []).filter(
      (x: any) => x.FORM_LINE_KEY === lineKey
        && x.IS_FORM_DISPLAY === 'Y'
    );
  }

  getRadioCells(lineKey: any): any[] {
    return (this.formList || []).filter(
      (x: any) => x.FORM_LINE_KEY === lineKey
        && x.EDIT_TYPE === 'radio'
    );
  }

  toDateInputFormat(value: string): string {
    if (!value) return '';
    const parts = String(value).split('/');
    if (parts.length !== 3) return value;
    return `${parts[2]}-${parts[0].padStart(2, '0')}-${parts[1].padStart(2, '0')}`;
  }

  onSelectInnerTab(part: string): void {
    this.innerTabSelect.emit(part);
  }

  onTextChange(item: any, event: any): void {
    const value = event?.target?.value ?? event;
    this.fieldChange.emit({ item, value });
  }

  onDateInputChange(item: any, event: Event): void {
    this.dateChange.emit({ item, event });
  }

  onDateVariousChangeIn(item: any): void {
    this.dateVariousChange.emit(item);
  }

  onDropdownInputChange(item: any, value: any): void {
    this.dropdownChange.emit({ item, value });
  }

  onCheckboxInputChange(item: any, event: any): void {
    this.checkboxChange.emit({ item, event });
  }

  onCheckBox8941(row1: any): void {
    this.checkBox8941.emit({
      lineKey: row1.FORM_LINE_KEY,
      attribKey: row1.LINE_ATTRIB_KEY,
      attribCol: row1.ATTRIB_COL
    });
  }

  trackByLineAttribKey(_: number, row: any): any {
    return row?.LINE_ATTRIB_KEY ?? row?.FORM_LINE_KEY ?? _;
  }
}
